import React, { useEffect, Suspense } from "react";
import styles from "./calendar-modal.module.css";

const MdOutlineClose = React.lazy(() => import('react-icons/md').then(module => ({ default: module.MdOutlineClose })));

export default function CalendarModal({ onClose }) {

    useEffect(() => {
        // Load Calendly script dynamically
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            // Cleanup script on unmount
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, []);

    return (
        <div className={styles.container}>
            {/* Close button positioned absolutely */}
            <div className={styles.close} onClick={onClose}>
                <Suspense fallback={<div>Loading...</div>}>
                    <MdOutlineClose color="#5F4DC7" size={24} />
                </Suspense>
            </div>
            
            {/* Calendly widget container */}
            <div className={styles.calendarContainer}>
                <div 
                    className="calendly-inline-widget" 
                    data-url="https://calendly.com/diya-karnik-schoolai" 
                    style={{ minWidth: '320px', height: '700px'}}
                ></div>
            </div>
        </div>
    );
}